import { render, staticRenderFns } from "./parcelaSimulacaoProposta.vue?vue&type=template&id=fabfd2b8"
import script from "./parcelaSimulacaoProposta.vue?vue&type=script&lang=js"
export * from "./parcelaSimulacaoProposta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports